import logo from './logo.svg';
import './App.css';
import { Router } from './pages';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
